/* eslint-disable prefer-rest-params */
export const hotjarInit = config => {
  const w = window;
  w.hj =
    w.hj ||
    function () {
      (w.hj.q = w.hj.q || []).push(arguments);
    };
  w._hjSettings = { hjid: config.hjid, hjsv: 5 };

  const head = document.getElementsByTagName('head')[0];
  const scriptElement = document.createElement('script');

  scriptElement.async = 1;
  scriptElement.src = `//static.hotjar.com/c/hotjar-${w._hjSettings.hjid}.js?sv=${w._hjSettings.hjsv}`;

  head.appendChild(scriptElement);
};
